export default "__VITE_ASSET__DsHRofhR__"